// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"5ef91ff8","85":"d95f29bb","248":"dde605f0","260":"76932bd3","400":"df37ec2b","460":"fd90b5aa","472":"033effb0","543":"21c1c3db","552":"4f41c5a4","680":"6d5c21ad","736":"6f4051bd","740":"7292c13a","916":"91f0b887"}[chunkId] + ".chunk.js";
};